import { SNoDataAvailable } from './table.styles';

export const NoDataAvailable = () => {
  return (
    <tr>
      <SNoDataAvailable colSpan={100}>No Data Available</SNoDataAvailable>
    </tr>
  );
};
